import { useContext, useState } from 'react';
import { FilterContext } from 'utils/context';
import {
  fetchShipments,
  getCount as getCountFetch,
} from 'utils/hooks/useSearchShipments/fetchShipments';

import {
  IFilters,
  ShipmentResDataDto,
  ShipmentSearchCriteriaDto,
} from '@project44-models/shipment-list';

const defaultData = ShipmentResDataDto.fromJSON({
  results: [],
  paginationInfo: {
    total: 0,
    pageSize: 1,
    pageNumber: 1,
  },
});

function useSearchShipments() {
  const [data, setData] = useState<ShipmentResDataDto>(defaultData);
  const [totalCount, setTotalCount] = useState(0);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { getShipmentsRequest } = useContext(FilterContext);

  const getCount = async (body?: IFilters) => {
    return await getCountFetch(body).catch(() => 0);
  };

  const doCount = async () => {
    try {
      const total = await getCount();
      setTotalCount(total);
    } catch {}
  };

  const doSearch = async (
    paginationInfo?: { page: number; size: number },
    additionalAttributes?: string[],
  ) => {
    const body = ShipmentSearchCriteriaDto.fromJSON({
      ...getShipmentsRequest(),
      ...(additionalAttributes?.length && {
        additionalFields: [
          {
            type: 'CUSTOM_ATTRIBUTES',
            keys: additionalAttributes,
          },
        ],
      }),
      paging: {
        pageSize: paginationInfo?.size || 20,
        pageNumber: paginationInfo?.page || 1,
      },
    });

    setIsError(false);
    setIsLoading(true);
    await fetchShipments(body)
      .then((data) => {
        setData(ShipmentResDataDto.fromJSON(data));
        setIsLoading(false);
      })
      .catch(() => {
        setData(defaultData);
        setIsError(true);
        setIsLoading(false);
      });
  };

  return {
    data,
    doCount,
    doSearch,
    getCount,
    isError,
    isLoading,
    totalCount,
  };
}

export default useSearchShipments;
